import React from 'react'
import styled from 'react-emotion'
import PropTypes from 'prop-types'
import { keys, omit } from 'util/objects'
import { Tooltip } from 'shared/ui'
import * as icons from 'assets/icons/groove'
import { colors } from './theme'

const View = ({ name, className, onClick, ...rest }) => {
  if (!(name in icons)) return null
  if (!icons[name]) return null
  const Icon = icons[name]
  const htmlProps = omit(['size', 'color', 'withTooltip', 'active'], rest)
  return <Icon className={className} onClick={onClick} {...htmlProps} />
}

const SVGIcon = styled(View)`
  display: inline-block;
  vertical-align: middle;
  width: ${({ size, width }) => width || size}px;
  height: ${({ size, height }) => height || size}px;
  color: inherit;
  line-height: 1;

  .fill {
    color: inherit;
    fill: ${({ color }) =>
      !color || color === 'inherit' ? 'currentColor' : colors[color]};
  }

  .stroke {
    color: inherit;
    stroke: ${({ color }) =>
      !color || color === 'inherit' ? 'currentColor' : colors[color]};
  }
`

SVGIcon.propTypes = {
  /* name of the corresponding .svg file in assets/icons/groove */
  name: PropTypes.string.isRequired,

  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,

  /* optional color name from the theme */
  color: PropTypes.oneOf([...keys(colors), 'inherit']),
  withTooltip: PropTypes.shape({
    tooltip: PropTypes.string,
    position: PropTypes.string,
  }),
}

SVGIcon.defaultProps = {
  size: 24,
  withTooltip: null,
}

// eslint-disable-next-line react/no-multi-comp
export default function SVGIconWrapper({ withTooltip, ...rest }) {
  return withTooltip ? (
    <Tooltip {...withTooltip}>
      <SVGIcon {...rest} />
    </Tooltip>
  ) : (
    <SVGIcon {...rest} />
  )
}
